module.exports = __webpack_public_path__ + "img/trial3-3.caefccac.png";